module.exports = [{"country":"中国","currency":"人名币","iocn":"￥","banks":[{"bank":"兴业银行"},{"bank":"中国银行"},{"bank":"农业银行"},{"bank":"工商银行"},{"bank":"中国建设银行"}],"type":[{"province":"福建","name":[{"city":"莆田"},{"city":"福州"}]},{"province":"广东","name":[{"city":"深圳"},{"city":"广州"}]}]},{"country":"美国","currency":"美元","iocn":"$","banks":[{"bank":"美国银行"}],"type":[{"province":"新英格兰","name":[{"city":"波士顿"},{"city":"奥古斯丁"}]},{"province":"中大西洋地区","name":[{"city":"华盛顿"},{"city":"纽约"}]}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/site.json
// module id = pt1B
// module chunks = 1